import * as React from 'react';
import {
	useCallback, useEffect, useRef, useState,
} from 'react';
import { Login as DefaultLogin, useDataProvider, useLogin } from 'react-admin';
import { Button, CardContent, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import bwipjs from 'bwip-js';
import SMSLoginForm from './SMSLoginForm';

const loginTypes = {
	QR: 'QR',
	password: 'password',
	SMS: 'SMS',
};

const styles = {
	QRButton: {
		display: 'block',
		width: '100%',
		marginBlockStart: '0.5rem',
	},
	QRContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
	refreshButton: {
		width: 'fit-content',
	},
	loginTypeTitle: {
		marginBlock: '1rem',
		textAlign: 'center',
	},
};

const QRLoginForm = ({ onTypePasswordClick, onTypePhoneClick }) => {
	const canvasRef = useRef();
	const checkTimeoutRef = useRef();
	const provider = useDataProvider();
	const login = useLogin();
	const [expired, setExpired] = useState(false);

	const checkQRResponse = useCallback((QRText) => {
		provider.runCloudFunction('checkQRResponse', { QRText })
			.then(({ data: { sessionToken, expired: QRExpired } }) => {
				if (sessionToken) {
					login({ sessionToken })
						.then(() => {});
				} else if (QRExpired === false) {
					checkTimeoutRef.current = setTimeout(() => checkQRResponse(QRText), 1000);
				} else {
					setExpired(true);
				}
			});
	}, [provider, login]);

	useEffect(() => {
		if (expired) {
			return () => {};
		}
		provider.runCloudFunction('requestQRChallenge')
			.then(({ data: { QRText } }) => {
				bwipjs.toCanvas({
					bcid: 'qrcode',
					text: QRText,
					scale: 3,
				},
				canvasRef.current);
				return QRText;
			})
			.then((QRText) => {
				checkTimeoutRef.current = setTimeout(() => checkQRResponse(QRText), 1000);
			});
		return () => { clearTimeout(checkTimeoutRef.current); };
	}, [expired, provider, checkQRResponse]);

	const handleRefreshClick = () => {
		setExpired(false);
	};

	return (
		<CardContent>
			<div>
				<div style={styles.QRContainer}>
					{
						expired
							? (
								<>
									<div>QR - код устарел. Нажмите чтобы обновить.</div>
									<IconButton style={styles.refreshButton} onClick={handleRefreshClick}>
										<RefreshIcon fontSize="large" color="primary" />
									</IconButton>
								</>
							)
							: <canvas ref={canvasRef} />
					}
				</div>
				<div style={styles.loginTypeTitle}>Войти другим способом</div>
				<Button onClick={onTypePasswordClick} style={styles.QRButton}>По паролю</Button>
				<Button onClick={onTypePhoneClick} style={styles.QRButton}>По номеру телефона</Button>
			</div>
		</CardContent>
	);
};

const LoginPage = ({ children, ...rest }) => {
	const [loginType, setLoginType] = useState(loginTypes.QR);

	const handleUsePassword = () => {
		setLoginType(loginTypes.password);
	};

	const handleUsePhone = () => {
		setLoginType(loginTypes.SMS);
	};

	if (loginType === loginTypes.password) {
		return <DefaultLogin {...rest}>{children}</DefaultLogin>;
	}
	if (loginType === loginTypes.SMS) {
		return (
			<DefaultLogin {...rest}>
				<SMSLoginForm />
			</DefaultLogin>
		);
	}
	return (
		<DefaultLogin {...rest}>
			<QRLoginForm onTypePasswordClick={handleUsePassword} onTypePhoneClick={handleUsePhone} />
		</DefaultLogin>
	);
};

export default LoginPage;
